import { render, staticRenderFns } from "./exhibitorList.vue?vue&type=template&id=3b3df308&scoped=true"
import script from "./exhibitorList.vue?vue&type=script&lang=js"
export * from "./exhibitorList.vue?vue&type=script&lang=js"
import style0 from "./exhibitorList.vue?vue&type=style&index=0&id=3b3df308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3df308",
  null
  
)

export default component.exports